export default function PrivacyPolicy() {
  return (
    <div className="page">
      <h2>Privacy Policy</h2>
      <p>
        Scaffolders Education respects your privacy. We collect only necessary
        information to provide courses, certification, and payments securely.
      </p>
    </div>
  );
}
